import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import AddIcon from "@mui/icons-material/Add";
import {
  Stack,
  Typography,
  Button,
  Grid,
  Avatar,
  MenuItem,
  ListItemIcon,
  Paper,
  Pagination,
  OutlinedInput,
  InputAdornment,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import DashboardLayout from "../../../../Layouts/Dashboard/dashboard";
import BoxPaper from "../../../../Components/Misc/BoxPaper";
import MoreMenu from "../../../../Components/Misc/MoreMenu";
import { routePaths } from "../../../../Router/router";
import CommentForm from "../../../../Components/Misc/CommentForm/comment-form";
import { useToggle } from "../../../../Utils/Hooks/useToggle";
import ContractDetailsCard from "../../../../Components/Cards/ContractDetailsCard/contract-details-card";
import CustomerUsersPanel from "../../../../Components/Panels/CustomerUsersPanel/customer-users-panel";
import SinglePageHeader, { SinglePageHeaderGroupActions } from "../../../../Components/Misc/SinglePageHeader";
import { useParams } from "react-router";
import React, { useState } from "react";
import { cacheService, orderService, rightService, thumbnailService, userService } from "../../../../Core/Api/services";
import { DbCustomerInfos } from "../../../../Core/Api/Types/db-customer-infos";
import { DbOrderItemInfos } from "../../../../Core/Api/Types/db-order-item-infos";
import GlobalConst from "../../../../Core/Utils/Constants/globals";
import moment from "moment";
import OrderHorizontalAdvancedCard from "../../../../Components/Cards/OrderHorizontalAdvancedCard";
import MetadataListTextItem from "../../../../Components/Misc/Metadata/MetadataListTextItem/metadata-list-text-item";
import { RightType } from "../../../../Core/Api/Types/right-type";
import { OrderStatus } from "../../../../Core/Api/Types/order-status";
import { UserAdvancedInfos } from "../../../../Core/Api/Types/user-advanced-infos";
import ModalAddCustomer, {
  ModalAddCustomerElementProps,
} from "../../../../Components/Modals/ModalAddCustomer/modal-add-customer";
import { ModalContext } from "../../../../Components/Modals";
import { ExportHandle } from "../../../../Components/Table/ProvidersTable/providers-table";
import usePagination from "../../../../Utils/Hooks/usePagination";
import TableCellBool from "../../../../Components/Table/TableCellBool";
import ListPageHeader, {
  ListPageHeaderGroupActions,
  ListPageHeaderRight,
} from "../../../../Components/Misc/ListPageHeader";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { OrderProductType } from "../../../../Core/Api/Types/order-product-type";
import ModalAddUser, { ModalAddUserElementProps } from "../../../../Components/Modals/ModalAddUser/modal-add-user";
import { ThumbnailSize } from "../../../../Core/Api/Thumbnail/thumbnail-api-service";
import OrderItemPanel from "../../../../Components/Panels/OrderItemPanel/order-item-panel";
import { UserHasAcl } from "../../../../Utils/helpers";
import { AclTypes } from "../../../../Core/Api/Types/acl-types";
import { useTranslation } from "react-i18next";

function CustomerSingle() {
  const { t } = useTranslation();
  const { active: commentFormVisible, toggle: toggleCommentForm } = useToggle();
  const { active: customerUsersPanel, toggle: toggleCustomerUsersPanel } = useToggle();
  const [customer, setCustomer] = React.useState<DbCustomerInfos>();
  const [rights, setRights] = React.useState<any[]>([]);
  const [costumerOrderItems, setCostumerOrderItems] = React.useState<DbOrderItemInfos[]>([]);
  const [costumerLinkedUsers, setCostumerLinkedUsers] = React.useState<UserAdvancedInfos[]>([]);
  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };
  const params = useParams();

  // Rights filters -----
  const [rightSearchPattern, setRightSearchPattern] = React.useState<string>("");
  const [delivered, setDelivered] = React.useState<string[]>([]);
  const [filterDelivered, setFilterDelivered] = React.useState<string>("Default");
  const [rightType, setRightType] = React.useState<string[]>([]);
  const [filterRightType, setFilterRightType] = React.useState<string>("Default");
  const [titleType, setTitleType] = React.useState<string[]>([]);
  const [filterTitleType, setFilterTitleType] = React.useState<string>("Default");

  React.useEffect(() => {
    setDelivered(Object.values(["True", "False"]));
    setTitleType(Object.values(["Movie", "Episode"]));
    setRightType(Object.values(RightType));
  }, [rights]);

  const handleFilterDelivered = (event: SelectChangeEvent<string>) => {
    setFilterDelivered(event.target.value as string);
  };
  const handleFilterRightType = (event: SelectChangeEvent<string>) => {
    setFilterRightType(event.target.value as string);
  };
  const handleFilterTitleType = (event: SelectChangeEvent<string>) => {
    setFilterTitleType(event.target.value as string);
  };

  const onRigthPatternChange: React.ChangeEventHandler<HTMLInputElement> = React.useCallback((e) => {
    setRightSearchPattern(e.currentTarget.value);
  }, []);
  // ----- End rights filters

  // Orders filters
  const [orderSearchPattern, setOrderSearchPattern] = React.useState<string>("");
  const [orderTypes, setOrdersTypes] = React.useState<string[]>([]);
  const [filterType, setFilterType] = React.useState<string>("Default");
  const [panelOrderItemOpen, setPanelOrderItemOpen] = React.useState<boolean>(false);
  const [selectedOrderItemId, setSelectedOrderItemId] = React.useState<number>(-1);
  const metadataFields = React.useMemo(() => cacheService.GetMetadata(), []);

  React.useEffect(() => {
    setOrdersTypes(Object.values(OrderProductType));
  }, [costumerOrderItems]);

  const handleFilterOrderType = (event: SelectChangeEvent<string>) => {
    setFilterType(event.target.value as string);
  };

  const onOrderPatternChange: React.ChangeEventHandler<HTMLInputElement> = React.useCallback((e) => {
    setOrderSearchPattern(e.currentTarget.value);
  }, []);
  // ----- End orders filters

  // Fetching data
  React.useEffect(() => {
    if (params.id) {
      orderService.GetCustomerById(parseInt(params.id)).then((response) => {
        if (response.customer) {
          setCustomer(response.customer);
        }
      });
      orderService.GetOrdersByCustomerId(parseInt(params.id)).then((response) => {
        if (response.items) setCostumerOrderItems(response.items);
      });
      rightService.GetRightContractsByCustomerId(parseInt(params.id), metadataFields, true).then((response) => {
        setRights(response);
      });
      userService.GetUsersListByCustomerId(parseInt(params.id)).then((response) => {
        if (response.users) {
          setCostumerLinkedUsers(response.users);
        }
      });
    }
  }, [params.id, metadataFields]);

  const handleEditCustomer = () => {
    if (!openModal) {
      return;
    }
    const onClose: ModalAddCustomerElementProps["onClose"] = (data) => {
      console.log(data);
    };
    openModal<ModalAddCustomerElementProps>(ModalAddCustomer, { onClose, context: "Edit", customer: customer });
  };

  const handleNewUserClick = React.useCallback(() => {
    if (!openModal) {
      return;
    }

    const onClose: ModalAddUserElementProps["onClose"] = (data) => {
      console.log(data);
    };

    openModal<ModalAddUserElementProps>(ModalAddUser, { onClose });
  }, [openModal]);

  //export
  const childRef = React.useRef<ExportHandle>(null);
  const handleExportClick = () => {
    childRef.current?.export();
  };

  // Pagination
  let filtredRigths = rights.filter(
    (x) =>
      (filterRightType === "Default" || filterRightType === "All" || x.type === filterRightType) &&
      (filterTitleType === "Default" || x.titleType === filterTitleType) &&
      (filterDelivered === "Default" ||
        (x.okDelivery === true && filterDelivered === "True") ||
        (x.okDelivery === false && filterDelivered === "False")) &&
      (rightSearchPattern === "" ||
        x.mediaNamesString?.toLowerCase().includes(rightSearchPattern.toLowerCase()) ||
        x.customerName?.toLowerCase().includes(rightSearchPattern.toLowerCase()) ||
        x.externalId?.toLowerCase().includes(rightSearchPattern.toLowerCase()) ||
        x.workRecordId?.toLowerCase().includes(rightSearchPattern.toLowerCase()) ||
        x.titleInfos?.name.toLowerCase().includes(rightSearchPattern.toLowerCase()))
  );
  let filtredOrders = costumerOrderItems.filter(
    (x) =>
      (filterType === "Default" || x.type === filterType) &&
      (orderSearchPattern === "" ||
        x.objectName?.toLowerCase().includes(orderSearchPattern.toLowerCase()) ||
        x.summarizedInfos?.toLowerCase().includes(orderSearchPattern.toLowerCase()))
  );
  const PER_PAGE = 2;
  const rightsCount = Math.ceil(filtredRigths.length / PER_PAGE);
  const ordersCount = Math.ceil(filtredOrders.length / PER_PAGE);
  const paginatedRights = usePagination(filtredRigths, PER_PAGE);
  const paginatedOrders = usePagination(filtredOrders, PER_PAGE);

  const handleRightPageChange = (e, p) => {
    paginatedRights.jump(p);
  };

  const handleOrderPageChange = (e, p) => {
    paginatedOrders.jump(p);
  };

  return (
    <DashboardLayout withContainer sxContent={{ px: 2, pb: 2 }}>
      <SinglePageHeader title={customer?.name || GlobalConst.LOADING_TEXT} mb={3}>
        <SinglePageHeaderGroupActions>
          <Button startIcon={<EditOutlinedIcon />} onClick={handleEditCustomer}>
            {t("common:editUpperCase")}
          </Button>
        </SinglePageHeaderGroupActions>

        <Button
          variant="contained"
          color="primary"
          startIcon={<FileDownloadOutlinedIcon />}
          onClick={handleExportClick}
          disabled={true}
        >
          {t("common:export")}
        </Button>
      </SinglePageHeader>
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <Paper elevation={0} sx={{ backgroundImage: "none", padding: "20px 24px", borderRadius: "12px", mb: 3 }}>
            <Typography variant="h5" component="h2">
              {t("common:contractsAndRights")}
            </Typography>
            <ListPageHeader elevated>
              <ListPageHeaderGroupActions elevated>
                <Select
                  displayEmpty
                  IconComponent={ExpandMoreRoundedIcon}
                  startAdornment={<SearchIcon />}
                  inputProps={{ "aria-label": "Without label" }}
                  MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
                  value={filterDelivered}
                  onChange={(value) => handleFilterDelivered(value)}
                >
                  <MenuItem value={"Default"}>{t("menu:item.isDelivered")}</MenuItem>
                  {delivered.map((type, index) => (
                    <MenuItem value={type} key={index}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>

                <Select
                  displayEmpty
                  IconComponent={ExpandMoreRoundedIcon}
                  startAdornment={<SearchIcon />}
                  inputProps={{ "aria-label": "Without label" }}
                  MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
                  value={filterRightType}
                  onChange={(value) => handleFilterRightType(value)}
                >
                  <MenuItem value={"Default"}>{t("menu:item.rightType")}</MenuItem>
                  {rightType.map((type, index) => (
                    <MenuItem value={type} key={index}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>

                <Select
                  displayEmpty
                  IconComponent={ExpandMoreRoundedIcon}
                  startAdornment={<SearchIcon />}
                  inputProps={{ "aria-label": "Without label" }}
                  MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
                  value={filterTitleType}
                  onChange={(value) => handleFilterTitleType(value)}
                >
                  <MenuItem value={"Default"}>{t("field:label.titleTypeLowerCase")}</MenuItem>
                  {titleType.map((type, index) => (
                    <MenuItem value={type} key={index}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </ListPageHeaderGroupActions>
              <ListPageHeaderRight>
                <OutlinedInput
                  label={t("common:search")}
                  placeholder={t("common:search")}
                  onChange={onRigthPatternChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  }
                />
              </ListPageHeaderRight>
            </ListPageHeader>
            {paginatedRights.currentData().length === 0 && (
              <Typography mt={2} color="text.tier">
                {t("page:body.noContractsAndRightsToShow")}
              </Typography>
            )}

            {paginatedRights.currentData().map((el, index) => (
              <Stack spacing={1} mt={2} key={index}>
                <ContractDetailsCard
                  contractId={el.titleId}
                  contractTitle={el.titleInfos.name}
                  customerName={el.customerName}
                  broadcaster={el.broadcasterName}
                  startDate={moment(el.startDate).format(GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS)}
                  endDate={moment(el.endDate).format(GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS)}
                  id={el.externalId}
                  workId={el.workRecordId}
                  externalId={el.externalId}
                  rightType={el.type}
                  languages={el.rightLanguagesString.trim().split(" ")}
                  territories={el.rightTerritoriesString.trim().split(" ")}
                  mediaName={el.mediaNamesString}
                  titleType={el.titleType}
                  okDelivery={el.okDelivery}
                  small
                />
              </Stack>
            ))}
            <Pagination
              sx={{ mt: 2 }}
              count={rightsCount}
              hideNextButton
              hidePrevButton
              onChange={handleRightPageChange}
            />
          </Paper>
          <Paper elevation={0} sx={{ backgroundImage: "none", padding: "20px 24px", borderRadius: "12px" }}>
            <Typography variant="h5" component="h2" mb={2}>
              {t("page:body.recentItems")}
            </Typography>
            <ListPageHeader elevated>
              <ListPageHeaderGroupActions elevated>
                <Select
                  displayEmpty
                  IconComponent={ExpandMoreRoundedIcon}
                  startAdornment={<SearchIcon />}
                  inputProps={{ "aria-label": "Without label" }}
                  MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
                  value={filterType}
                  onChange={(value) => handleFilterOrderType(value)}
                >
                  <MenuItem value={"Default"}>{t("menu:item.orderType")}</MenuItem>
                  {orderTypes.map((type, index) => (
                    <MenuItem value={type} key={index}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </ListPageHeaderGroupActions>
              <ListPageHeaderRight>
                <OutlinedInput
                  label={t("common:search")}
                  placeholder={t("common:search")}
                  onChange={onOrderPatternChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  }
                />
              </ListPageHeaderRight>
            </ListPageHeader>
            <Stack spacing={2}>
              {paginatedOrders.currentData().length === 0 && (
                <Typography mt={2} color="text.tier">
                  {t("page:body.noRecentItemsToShow")}
                </Typography>
              )}
              {paginatedOrders.currentData().map((item, index) => (
                <OrderHorizontalAdvancedCard
                  key={index}
                  title={item.objectName || "-"}
                  itemId={item.id}
                  titleId={item.relatedTitleId}
                  subtitle={item.objectLayer}
                  thumbnail={thumbnailService.GetObjectPosterUrl(item.relatedTitleId, ThumbnailSize.small)}
                  priority={item.priority}
                  config={{
                    title: item.summarizedInfos || "-",
                    configType: item.type,
                    price:
                      item.price && item.price.price && item.price.currency
                        ? item.price.price + item.price.currency
                        : "-",
                    content: { setting: item.type, voice: "" },
                    attachement: "",
                  }}
                  onClickConfigDetails={() => {
                    setSelectedOrderItemId(item.id);
                    setPanelOrderItemOpen(true);
                  }}
                />
              ))}
              <Pagination count={ordersCount} hideNextButton hidePrevButton onChange={handleOrderPageChange} />
            </Stack>
          </Paper>
        </Grid>
        <Grid item xs={4}>
          <BoxPaper mb={3} title={t("common:summary")}>
            <Stack mb={3}>
              <Typography variant="h6" color="text.tier" mb={2}>
                {t("panel:accordionTitle.globalInfos")}
              </Typography>
              <Stack spacing={1.5}>
                <MetadataListTextItem title={t("menu:title.fullName")}>{customer?.name}</MetadataListTextItem>
                <MetadataListTextItem title={t("menu:title.databaseId")}>{customer?.id}</MetadataListTextItem>
                <MetadataListTextItem title={t("menu:title.clientExternalId")}>
                  {customer?.customerCodeId}
                </MetadataListTextItem>
                <MetadataListTextItem title={t("common:enability")}>
                  <TableCellBool value={!customer?.addedManually} />
                </MetadataListTextItem>
                <MetadataListTextItem title={t("menu:title.addedManually")}>
                  <TableCellBool value={!customer?.disabled} />
                </MetadataListTextItem>
              </Stack>
            </Stack>
            <Stack mb={3}>
              <Typography variant="h6" color="text.tier" mb={2}>
                {t("panel:accordionTitle.contractsAndRightsInfos")}
              </Typography>
              <Stack spacing={1.5}>
                <MetadataListTextItem title={t("menu:title.numOfContracts")}>{rights.length}</MetadataListTextItem>
                <MetadataListTextItem title={t("menu:title.disposalContracts")}>
                  {rights.filter((contract) => contract.type === RightType.Disposal).length}
                </MetadataListTextItem>
                <MetadataListTextItem title={t("menu:title.acquisitionContracts")}>
                  {rights.filter((contract) => contract.type === RightType.Acquisition).length}
                </MetadataListTextItem>
              </Stack>
            </Stack>
            <Stack mb={3}>
              <Typography variant="h6" color="text.tier" mb={2}>
                {t("panel:accordionTitle.ordersInfos")}
              </Typography>
              <Stack spacing={1.5}>
                <MetadataListTextItem title={t("menu:title.numbersOfOrders")}>
                  {costumerOrderItems.length}
                </MetadataListTextItem>
                <MetadataListTextItem title={t("menu:title.completedOrders")}>
                  {costumerOrderItems.filter((or) => or.status === OrderStatus.COMPLETED).length}
                </MetadataListTextItem>
                <MetadataListTextItem title={t("menu:title.rejectedOrders")}>
                  {
                    costumerOrderItems.filter(
                      (or) =>
                        or.status === OrderStatus.CANCELED ||
                        or.status === OrderStatus.FAILED ||
                        or.status === OrderStatus.ABORTED
                    ).length
                  }
                </MetadataListTextItem>
              </Stack>
            </Stack>
          </BoxPaper>
          <BoxPaper
            mb={3}
            title={t("page:boxPaper.title.activeUsers")}
            rightContent={
              <Button
                variant="outlined"
                size="small"
                color="primary"
                startIcon={<PersonAddAltOutlinedIcon />}
                onClick={handleNewUserClick}
                disabled={!UserHasAcl(AclTypes.aclBackofficeUserCreate)}
              >
                {t("button:newUser")}
              </Button>
            }
          >
            {costumerLinkedUsers &&
              costumerLinkedUsers.slice(0, 5).map((user) => (
                <ul key={user.userInfos?.id}>
                  <Stack component="li" direction="row" alignItems="center" justifyContent="space-between">
                    <Stack direction="row" alignItems="center">
                      <Avatar sx={{ width: 36, height: 36 }}></Avatar>
                      <Typography fontWeight={500} ml={1}>
                        {user.userInfos?.name}
                      </Typography>
                    </Stack>

                    <MoreMenu>
                      <MenuItem>
                        <ListItemIcon>
                          <EditOutlinedIcon fontSize="small" />
                        </ListItemIcon>
                        {t("menu:item.editUserInfo")}
                      </MenuItem>
                      <MenuItem disabled>
                        <ListItemIcon>
                          <DeleteOutlineOutlinedIcon fontSize="small" />
                        </ListItemIcon>
                        {t("common:remove")}
                      </MenuItem>
                      <MenuItem disabled>
                        <ListItemIcon>
                          <MoreHorizOutlinedIcon fontSize="small" />
                        </ListItemIcon>
                        {t("common:moreInfo")}
                      </MenuItem>
                    </MoreMenu>
                  </Stack>
                </ul>
              ))}
            {costumerLinkedUsers.length === 0 && (
              <Typography color="text.tier" fontWeight={500} ml={1}>
                {t("page:body.noUsersToShow")}
              </Typography>
            )}
            {costumerLinkedUsers.length > 2 && (
              <Button sx={{ mt: 3 }} onClick={toggleCustomerUsersPanel} fullWidth>
                {t("button:viewMore")}
              </Button>
            )}
          </BoxPaper>
          <BoxPaper
            mb={3}
            title={t("common:activities")}
            rightContent={
              <Button size="small" startIcon={<AddIcon />} onClick={toggleCommentForm}>
                {t("common:comment")}
              </Button>
            }
          >
            <Typography color="text.tier" fontWeight={500} ml={1}>
              {t("page:body.noActivitiesToShow")}
            </Typography>
            {commentFormVisible && <CommentForm onSend={() => false} />}
          </BoxPaper>
        </Grid>
      </Grid>
      <CustomerUsersPanel
        open={customerUsersPanel}
        onClose={toggleCustomerUsersPanel}
        users={costumerLinkedUsers}
        header={customer?.name || ""}
        isAdvancedUser
      />
      <OrderItemPanel
        open={panelOrderItemOpen}
        onClose={() => setPanelOrderItemOpen(false)}
        itemId={selectedOrderItemId}
      />
    </DashboardLayout>
  );
}

export default CustomerSingle;
